import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _asyncToGenerator from '@babel/runtime/helpers/asyncToGenerator';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import _regeneratorRuntime from '@babel/runtime/regenerator';
import { useState, useCallback, useEffect } from 'react';
import * as TDSIcons from '@tesla/design-system-icons';
import icons from './customIcons.js';
import fetchFunctions from './fetchFunctions.js';
import utils from './utils.js';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var useGlobalSiteHeaderConfig = function useGlobalSiteHeaderConfig(_ref) {
  var _appSwitcherProps$app, _appSwitcherConfig$ap;
  var osAccessToken = _ref.osAccessToken,
    aosUrl = _ref.aosUrl,
    locale = _ref.locale,
    appName = _ref.appName,
    appSwitcherProps = _ref.appSwitcherProps;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    loading = _useState2[0],
    setloading = _useState2[1];
  var _useState3 = useState({
      applications: utils.transformAppSwitcherProps(appSwitcherProps)
    }),
    _useState4 = _slicedToArray(_useState3, 2),
    appSwitcherConfig = _useState4[0],
    setAppSwitcherConfig = _useState4[1];
  var skip = (appSwitcherProps === null || appSwitcherProps === void 0 ? void 0 : appSwitcherProps.applications) && (appSwitcherProps === null || appSwitcherProps === void 0 ? void 0 : (_appSwitcherProps$app = appSwitcherProps.applications) === null || _appSwitcherProps$app === void 0 ? void 0 : _appSwitcherProps$app.length);
  var fetchGlobalSiteHeaderConfig = useCallback(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var _configs$appSwitcher, _configs$appSwitcher5, applications, configs, _configs$appSwitcher2, _configs$appSwitcher3, _configs$appSwitcher4;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (loading) {
            _context.next = 15;
            break;
          }
          setloading(true);
          _context.prev = 2;
          applications = [];
          _context.next = 6;
          return fetchFunctions.getGlobalSiteHeaderConfig({
            osAccessToken: osAccessToken,
            aosUrl: aosUrl,
            locale: locale,
            appName: appName
          });
        case 6:
          configs = _context.sent;
          if (configs !== null && configs !== void 0 && configs.appSwitcher && (_configs$appSwitcher = configs.appSwitcher) !== null && _configs$appSwitcher !== void 0 && _configs$appSwitcher.applications) {
            applications = configs === null || configs === void 0 ? void 0 : (_configs$appSwitcher2 = configs.appSwitcher) === null || _configs$appSwitcher2 === void 0 ? void 0 : (_configs$appSwitcher3 = _configs$appSwitcher2.applications) === null || _configs$appSwitcher3 === void 0 ? void 0 : (_configs$appSwitcher4 = _configs$appSwitcher3.map(function (app) {
              if ((app === null || app === void 0 ? void 0 : app.imgName) === 'teslaIconBase64' || TDSIcons[app === null || app === void 0 ? void 0 : app.imgName]) {
                return _objectSpread(_objectSpread({}, app), {}, {
                  img: (app === null || app === void 0 ? void 0 : app.imgName) === 'teslaIconBase64' ? icons.teslaIconBase64 : TDSIcons[app === null || app === void 0 ? void 0 : app.imgName]
                });
              }
              return null;
            })) === null || _configs$appSwitcher4 === void 0 ? void 0 : _configs$appSwitcher4.filter(Boolean);
          }
          setAppSwitcherConfig({
            title: configs === null || configs === void 0 ? void 0 : (_configs$appSwitcher5 = configs.appSwitcher) === null || _configs$appSwitcher5 === void 0 ? void 0 : _configs$appSwitcher5.title,
            applications: applications
          });
          _context.next = 14;
          break;
        case 11:
          _context.prev = 11;
          _context.t0 = _context["catch"](2);
          setAppSwitcherConfig({});
        case 14:
          setloading(false);
        case 15:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[2, 11]]);
  })), [osAccessToken]);
  useEffect(function () {
    if (loading || skip) {
      return;
    }
    fetchGlobalSiteHeaderConfig({
      osAccessToken: osAccessToken,
      aosUrl: aosUrl
    });
  }, [osAccessToken]);
  return {
    loading: loading,
    show: (appSwitcherProps === null || appSwitcherProps === void 0 ? void 0 : appSwitcherProps.show) && (appSwitcherConfig === null || appSwitcherConfig === void 0 ? void 0 : appSwitcherConfig.applications) && (appSwitcherConfig === null || appSwitcherConfig === void 0 ? void 0 : (_appSwitcherConfig$ap = appSwitcherConfig.applications) === null || _appSwitcherConfig$ap === void 0 ? void 0 : _appSwitcherConfig$ap.length),
    appSwitcherConfig: appSwitcherConfig
  };
};

export { useGlobalSiteHeaderConfig as default };
